import { render } from "./EditSupport.vue?vue&type=template&id=157b1364&scoped=true&ts=true"
import script from "./EditSupport.vue?vue&type=script&lang=ts"
export * from "./EditSupport.vue?vue&type=script&lang=ts"

import "./EditSupport.vue?vue&type=style&index=0&id=157b1364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157b1364"]])

export default __exports__